import { ApiProperty } from "@nestjs/swagger";
import { AssetStatusEnum } from "libs/shared-models/common-models/src/lib/enum/asset-status.enum";

export class AbstractDetails{
    @ApiProperty()
    assetCategory: string;

    @ApiProperty()
    status: AssetStatusEnum;
}